var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7775 13.8674H2.22699C1.87423 13.8674 1.58743 14.1565 1.58743 14.507V15.3605C1.58743 15.7132 1.8765 16 2.22699 16H13.7729C14.1257 16 14.4125 15.7109 14.4125 15.3605V14.507C14.4193 14.1519 14.1303 13.8674 13.7775 13.8674Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55501 12.7226C7.6802 12.8478 7.84407 12.9115 8.00565 12.9115C8.16952 12.9115 8.33339 12.8478 8.45629 12.7226L12.8307 8.34822C13.0788 8.10016 13.0788 7.69504 12.8307 7.44239L12.2253 6.83698C11.9772 6.58889 11.5721 6.58889 11.3195 6.83698L9.0708 9.08792V0.63956C9.0708 0.286771 8.78174 0 8.43127 0H7.57777C7.22501 0 6.93821 0.28448 6.93821 0.63956V9.09019L4.6873 6.83925C4.4392 6.59118 4.03182 6.59118 3.78146 6.83925L3.17606 7.44465C2.92799 7.69272 2.92799 8.10013 3.17606 8.35048L7.55501 12.7226Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.a7436c63e3ba912ba9c5188a5e2d4f30.svg";
export { ForwardRef as ReactComponent };